import { createI18n } from "vue-i18n"
import { RouteLocationNormalized, RouteRecordName } from "vue-router"
import common from "@/i18n/common"
import eventType from "@/i18n/eventType"
// import menu from "./menu.js"
// import login from "./login.js"
// import report from "./report.js"
// import evnetType from "@/i18n/eventType"

type SupportLocales = "en" | "cn"

interface PageConfig {
  [key: RouteRecordName]: {
    name: RouteRecordName
    file: () => Promise<{ default: Record<string, unknown> }>
  }[]
}

const pageConfig: PageConfig = {
  FullMarket: [
    {
      name: "fullMarket",
      file: async () => import("@/i18n/fullMarket")
    },
    {
      name: "liveScore",
      file: async () => import("@/i18n/liveScore")
    }
  ],
  Highlight: [
    {
      name: "highlight",
      file: async () => import("@/i18n/sports")
    },
    {
      name: "horse",
      file: async () => import("@/i18n/horse")
    }
  ],
  MultiMarket: [
    {
      name: "fullMarket",
      file: async () => import("@/i18n/fullMarket")
    }
  ],
  Horse: [
    {
      name: "sports",
      file: async () => import("@/i18n/sports")
    },
    {
      name: "horse",
      file: async () => import("@/i18n/horse")
    }
  ],
  Home: [
    {
      name: "sports",
      file: async () => import("@/i18n/sports")
    },
    {
      name: "horse",
      file: async () => import("@/i18n/horse")
    }
  ],
  Greyhound: [
    {
      name: "sports",
      file: async () => import("@/i18n/sports")
    },
    {
      name: "greyhound",
      file: async () => import("@/i18n/horse")
    },
    {
      name: "horse",
      file: async () => import("@/i18n/horse")
    }
  ]
}

const i18n = createI18n({
  legacy: false, // you must set `false`, to use Composition API
  locale: "en",
  fallbackLocale: "en",
  modifiers: {
    // Adding a new modifier
  },
  messages: {
    en: {
      common: common.en,
      eventType: eventType.en
    },
    cn: {
      common: common.cn,
      eventType: eventType.cn
    }
  }
})

export function setI18nLanguage(locale: SupportLocales) {
  i18n.global.locale.value = locale
  // /**
  //  * NOTE:
  //  * If you need to specify the language setting for headers, such as the `fetch` API, set it here.
  //  * The following is an example for axios.
  //  *
  //  * axios.defaults.headers.common['Accept-Language'] = locale
  //  */
  document.querySelector("html")?.setAttribute("lang", locale)
}

const getPageName = (to: RouteLocationNormalized) => {
  const pageName = to.name || ""
  if (pageName === "Home") {
    const path = to.path.split("/").pop() ?? ""
    const name = path.replace(/(^\w|-\w)/g, match => match.replace("-", "").toUpperCase())

    return pageConfig[name]
  }

  return pageConfig[pageName]
}

export async function loadLocaleMessages(to: RouteLocationNormalized) {
  // load locale messages with dynamic import
  const locale = "en"

  const pageName = getPageName(to)

  if (typeof to.name === "string" && pageName) {
    const messagePromises = pageName.map(async config => {
      const { name, file } = config
      const messages = await file()
      return { [name]: messages.default[locale] }
    })

    const messagesArray = await Promise.all(messagePromises)
    const localeMessage = messagesArray.reduce((acc, cur) => ({ ...acc, ...cur }), {})

    // set locale and locale message
    i18n.global.mergeLocaleMessage(locale, localeMessage)

    return nextTick()
  }
  console.warn(
    typeof to.name === "string"
      ? `Locale messages for page "${to.name}" not found.`
      : "Route name is not a string."
  )
  return Promise.resolve()
}

export default i18n
